export interface SettingsModel {
  languageId: number;
}
